import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ContentWrapper from "../../components/contentwrapper/ContentWrapper";
import { Form, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { fetchAllDataAPI, filterByParams } from "../../utils/api";
import Skeleton from "react-loading-skeleton";
import { numberFormat } from "../../utils/numberFormat";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from "moment";
import ReportNavBar from "../../components/ReportNavBar";

const AgentWiseReport = () => {
    const [report, setReport] = useState([]);
    const [filteredReport, setFilteredReport] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: new Date().toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US'),
    });
    const [filterdate, setFilterDate] = useState(null);

    const adminid = localStorage.getItem("admindata");
    const navigate = useNavigate();

    useEffect(() => {
        if (!adminid) {
            navigate("/");
        } else {
            getReportMonthWise();
        }
    }, [adminid]);

    const getReportMonthWise = async () => {
        setIsLoading(true);
        try {
            const res = await fetchAllDataAPI("super-admin-get-delivery-report-month-agent-wise");
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        } catch (error) {
            console.error("Error fetching report:", error);
        }
        setIsLoading(false);
    };
    const handleCenterReportRange = async (event, picker) => {
        setIsLoading(true);
        const selectedRange = {
            startDate: picker.startDate.format("YYYY-MM-DD"),
            endDate: picker.endDate.format("YYYY-MM-DD"),
        };
        setFilterDate(selectedRange);
        try {
            const res = await filterByParams("super-admin-get-filter-delivery-report-month-agent-wise", selectedRange);
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        }
        catch (error) {
            console.error("Error fetching report:", error);
        }
        setIsLoading(false);
    };
    const handleReset = () => {
        setSearchTerm("");
        setFilteredReport(report);
    };
    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filteredData = report.filter(item =>
            item.agent_name.toLowerCase().includes(value) ||
            item.center_name.toLowerCase().includes(value)
        );
        setFilteredReport(filteredData);
    };
    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR: REPORT</title>
            </Helmet>
            <ContentWrapper>
                <ReportNavBar />
                <div className="card p-2" style={{ marginBottom: "50px" }}>
                    <div className="heading d-flex justify-content-between mb-2">
                        <h5 className="mb-0 text-uppercase mt-2">
                            {filterdate && filterdate.startDate && filterdate.endDate
                                ? `Reports from ${moment(filterdate.startDate).format("MMMM D, YYYY")} TO ${moment(filterdate.endDate).format("MMMM D, YYYY")}`
                                : `Reports from ${moment().startOf("month").format("MMMM D, YYYY")} TO ${moment().format("MMMM D, YYYY")}`
                            }
                        </h5>
                        <div className="mt-1">
                            <Form.Control
                                type="text"
                                placeholder="Search by Center And Agent Name"
                                value={searchTerm}
                                onChange={handleSearch}
                                className="mb-3"
                            />
                        </div>
                        <div>
                            <span onClick={handleReset} className="btnreset">Reset</span>
                            <DateRangePicker
                                initialSettings={{
                                    startDate: dateRange.startDate,
                                    endDate: dateRange.endDate,
                                }}
                                onApply={handleCenterReportRange}
                            >
                                <button className="btn btn-sm btndateramge">Select Date Range</button>
                            </DateRangePicker>
                        </div>
                    </div>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Agent Name</th>
                                    <th>Center Name</th>
                                    <th>Number Of Orders</th>
                                    <th>Number Of Delivered</th>
                                    <th>Delivered Order Wise(%)</th>
                                    <th>Delivered Value Wise(%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <>
                                        {[...Array(5)].map((_, index) => (
                                            <tr key={index}>
                                                {Array.from({ length: 7 }).map((_, index) => (
                                                    <td key={index}><Skeleton animation="wave" variant="text" /></td>
                                                ))}
                                            </tr>
                                        ))}
                                    </>
                                ) :
                                    filteredReport.length > 0 ? (
                                        filteredReport.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.agent_name}({item?.agent_emp_id})</td>
                                                <td>{item.center_name}</td>
                                                <td>{item.total_orders}</td>
                                                <td>{item.delivered_orders}</td>
                                                <td>
                                                    <div className="d-flex" style={{ gap: "10px" }}>
                                                        <span style={{ fontWeight: "600" }}>{Number(item.delivered_percentage || 0).toFixed(2)}%</span>
                                                        <span>({numberFormat(item.total_revenue)})</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex" style={{ gap: "10px" }}>
                                                        <span style={{ fontWeight: "600" }}>{Number(item.delivered_value_percentage || 0).toFixed(2)}%</span>
                                                        <span>({numberFormat(item.delivered_value)})</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th className="text-end" style={{ fontWeight: "600", color: "#000" }} colSpan={3}>Grand Total</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{filteredReport.reduce((acc, item) => acc + Number(item.total_orders || 0), 0)}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>{filteredReport.reduce((acc, item) => acc + Number(item.delivered_orders || 0), 0)}</th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>
                                        <div className="d-flex" style={{ gap: "10px" }}>
                                            <span style={{ fontWeight: "600" }}>
                                                {(
                                                    filteredReport.reduce((acc, item) => acc + Number(item.delivered_percentage || 0), 0) /
                                                    (filteredReport.length || 1)
                                                ).toFixed(2)}%
                                            </span>
                                            <span>
                                                ({numberFormat(filteredReport.reduce((acc, item) => acc + Number(item.total_revenue || 0), 0))})
                                            </span>
                                        </div>
                                    </th>
                                    <th style={{ fontWeight: "600", color: "#000" }}>
                                        <div className="d-flex" style={{ gap: "10px" }}>
                                            <span style={{ fontWeight: "600" }}>
                                                {(
                                                    filteredReport.reduce((acc, item) => acc + Number(item.delivered_value_percentage || 0), 0) /
                                                    (filteredReport.length || 1)
                                                ).toFixed(2)}%
                                            </span>
                                            <span>
                                                ({numberFormat(filteredReport.reduce((acc, item) => acc + Number(item.delivered_value || 0), 0))})
                                            </span>
                                        </div>
                                    </th>
                                </tr>
                            </tfoot>

                        </Table>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};

export default AgentWiseReport;
